import {
  makeStyles,
  shorthands,
  tokens,
  typographyStyles,
} from '@fluentui/react-components';

export const useCommonDialogueStyles = makeStyles({
  container: {
    ...typographyStyles.body1,
    ...shorthands.overflow('hidden'),
    ...shorthands.padding(tokens.spacingVerticalL, tokens.spacingHorizontalXXL),
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    columnGap: tokens.spacingHorizontalL,
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      columnGap: tokens.spacingHorizontalS,
    },
  },
  horizontalDivider: {
    width: '100%',
    ...shorthands.margin(tokens.spacingVerticalS, tokens.spacingHorizontalNone),
  },
  dialogueContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingHorizontalNone, tokens.spacingVerticalL),
  },
  dismissIcon: {
    cursor: 'pointer',
  },
  searchBoxWrapper: {
    ...shorthands.flex(1),
    position: 'relative',
    minHeight: '90px',
    ...shorthands.borderRadius(tokens.borderRadiusXLarge),
  },
  searchBox: {
    width: '100%',
    height: '100%',
    ...shorthands.gap(tokens.spacingVerticalS, tokens.spacingHorizontalS),
    ...shorthands.borderRadius(tokens.borderRadiusXLarge),

    '&::after': {
      paddingTop: tokens.spacingVerticalS,
      borderBottomRightRadius: tokens.borderRadiusXLarge,
      borderBottomLeftRadius: tokens.borderRadiusXLarge,
    },
  },
  loadingText: {
    marginBlockEnd: '0',
    color: tokens.colorNeutralStroke1,
    marginBlockStart: tokens.spacingVerticalXXL,
  },
  loadingContainer: {
    position: 'absolute',
    bottom: '0',
    left: '0',
    right: '0',
    width: '100%',
    zIndex: '1',
  },
  footer: {
    marginTop: tokens.spacingVerticalS,
  },
  warningFooter: {
    gridColumnEnd: 'auto',
    gridColumnStart: 'auto',
    justifySelf: 'start',
  },
});

export const useCreateWithWebsiteDialogueStyles = makeStyles({
  domainInputWrapper: {
    width: '100%',
  },
  suggestionErrorInvalid: {
    marginTop: tokens.spacingVerticalXS,
    ...typographyStyles.caption1,
  },
});
